module.exports = __webpack_public_path__ + "static/img/man.964c5e4c.svg";